import { subscribeToModules, type MedicalModuleWithId } from '@/services/medical-modules-service';
import type { ModuleType } from '@flintmint/core-shared/firestore/schemas';

import { useFirestoreSubscription } from './use-firestore-subscription';

export const useMedicalModules = (types: ModuleType[]) => {
  const typesKey = types.join(',');

  const { data, isLoading, error } = useFirestoreSubscription<MedicalModuleWithId>(
    (onData, onError) => subscribeToModules(types, onData, onError),
    [typesKey]
  );

  return {
    modules: data,
    isLoading,
    error,
  };
};
